import {ComponentPropsWithRef, createElement, forwardRef} from 'react';
import {getElementAttributes} from '../../helpers/get-element-attributes';
import css from './flex.module.scss';

interface Props extends Omit<ComponentPropsWithRef<'div'>, 'className'> {
  tag?: string;
  className?: string | string[];
}

export const Flex = forwardRef<HTMLDivElement, Props>(({tag = 'div', className, ...props}, ref) =>
  createElement(tag, {
    ...getElementAttributes(props),
    className: css('flex', props, className),
    ref,
  })
);
